import { logout } from 'redux/actions'

export default function checkToken(response, dispatch) {
  const isTokenInvalid = response?.code === 212
  if (isTokenInvalid) {
    dispatch(logout())
  }
}
